import React, { useState } from 'react';
import glamorous, { Div } from 'glamorous';

import { colors, Bubble } from 'react-chui';

const BUBBLE_OPTIONS = {
  attachment: 'middle left',
  targetOffset: '0 10px',
};

const InfoBubbleContent = glamorous(Bubble, { displayName: 'InfoBubbleContent' })({
  width: '500px',
});

const InfoBubbleFlexBox = glamorous('div', { displayName: 'InfoBubbleFlexBox' })({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'left',
});

const InfoBubbleIcon = glamorous('i', { displayName: 'InfoBubbleIcon' })({
  cursor: 'pointer',
  marginLeft: '16px',
  fontSize: '28px',
  color: colors.brightblue,
});

const InfoCloseIcon = glamorous('i', { displayName: 'InfoCloseIcon' })({
  cursor: 'pointer',
  float: 'right',
  padding: '8px',
  fontSize: '20px',
});

const InfoMessageBubble = ({ message, info }) => {
  const [showBubble, setShowBubble] = useState(false);
  const toggleBubble = () => {
    setShowBubble(!showBubble);
  };

  return (
    <InfoBubbleIcon className={'ch-icon-circlequestion'} onClick={() => toggleBubble()}>
      {showBubble && (
        <InfoBubbleContent tetherOptions={BUBBLE_OPTIONS} onRequestClose={() => toggleBubble()}>
          <InfoBubbleFlexBox>
            <Div style={{ margin: '16px' }}>{message}</Div>
            <InfoCloseIcon className='ch-icon-circlex' onClick={() => toggleBubble()} />
          </InfoBubbleFlexBox>
        </InfoBubbleContent>
      )}
    </InfoBubbleIcon>
  );
};
InfoMessageBubble.displayName = 'InfoMessageBubble';

export default InfoMessageBubble;
